import classNames from "classnames";
import LanguageSwitcher from "localization/LanguageSwitcher";
import { RootState } from "index";
import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "sass/components/Header.scss";
import { useTranslation } from "react-i18next";

type MenuProps = SubMenuProps & {
  name: string;
  link: string;
  navActive: boolean;
  selected: boolean;
  onMenuClick?: () => void;
};

type SubMenuType = {
  title: string;
  path: string;
};

export type SubMenuProps = {
  submenus: SubMenuType[];
  dropdownActive: boolean;
};

function Menu({
  name,
  link,
  submenus,
  navActive,
  selected,
  onMenuClick,
}: MenuProps) {
  const [dropdownActive, setDropdownActive] = useState(false);

  const handleMenuItemClick = () => {
    if (onMenuClick) {
      onMenuClick();
    }
  };

  return (
    <li className={classNames("nav-menu-item", { active: selected })}>
      {/* mobile */}
      {navActive && submenus.length > 0 ? (
        <>
          <div
            className={classNames("nav-menu-dropdown", {
              active: dropdownActive,
            })}
            onClick={() => {
              setDropdownActive(!dropdownActive);
            }}
          >
            <p className={classNames("nav-menu-title", { active: selected })}>
              {name}
            </p>
          </div>
          {
            <SubMenu
              submenus={submenus}
              dropdownActive={dropdownActive}
            ></SubMenu>
          }
        </>
      ) : (
        // desktop and mobile without submenus
        <>
          <Link to={link} onClick={handleMenuItemClick}>
            <p className={classNames("nav-menu-title", { active: selected })}>
              {name}
            </p>
          </Link>
          {submenus.length > 0 && (
            <SubMenu submenus={submenus} dropdownActive></SubMenu>
          )}
        </>
      )}
    </li>
  );
}

Menu.defaultProps = { submenus: [], dropdownActive: false };

function SubMenu({ submenus, dropdownActive }: SubMenuProps) {
  return (
    <ul className={classNames("nav-sub", { active: dropdownActive })}>
      {submenus.map((sub, i) => (
        <li className="nav-sub-item" key={i}>
          <Link to={sub.path} reloadDocument>
            <p>{sub.title}</p>
          </Link>
        </li>
      ))}
    </ul>
  );
}

function Header() {
  const { t } = useTranslation();
  const [navActive, setNavActive] = useState(false);
  const currentPageIndex = useSelector(
    (state: RootState) => state.pageIndex.index
  );

  const handleMenuClick = () => {
    setNavActive(false);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="nav-logo">
          <a href="/">
            Lingple
            {/* <img alt="" src="/img/ic_logo_lingple.png" /> */}
          </a>
        </div>
        <div className="flex items-center">
          <div className="md:hidden mr-4">
            <LanguageSwitcher fromMenu={true} />
          </div>
          <div
            className="nav-menu-button"
            onClick={() => {
              setNavActive(!navActive);
            }}
          >
            <i className="fas fa-bars text-xl text-gray-300" />
          </div>
        </div>
        <nav className={navActive ? "nav active" : "nav"}>
          <div className="header-login">
            {/* <Link to="login" reloadDocument>
            <p>로그인</p>
          </Link>
          <Link to="signup" reloadDocument>
            <p>회원가입</p>
          </Link> */}
          </div>
          <ul className="nav-menu">
            <Menu
              name={t("home")}
              link="/"
              navActive={navActive}
              selected={currentPageIndex === 0}
              onMenuClick={handleMenuClick}
            ></Menu>
            <Menu
              name={t("about")}
              link="/about"
              navActive={navActive}
              selected={currentPageIndex === 1}
              onMenuClick={handleMenuClick}
            ></Menu>
            <li className="md:block hidden ml-4">
              <LanguageSwitcher fromMenu={true} />
            </li>
          </ul>
        </nav>
      </div>
      {/* 모바일 메뉴 오버레이 클릭 시 메뉴 닫기 */}
      {navActive && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setNavActive(false)}
        />
      )}
    </header>
  );
}

export default Header;
